(function($, Drupal, drupalSettings) {

  Drupal.behaviors.user_edit_form = {
    attach: function (context, settings) {

      if ($('body').hasClass('page--account--edit')) {
        $('#user-form .form-actions').addClass('mba_btn_001a');
      }

      if ($('form.profile-customer-form').length) {
        $('form.profile-customer-form .form-actions').addClass('mba_btn_001a');

        var options = {};
        options.width = Drupal.webform.select2.options.widthInline;
        options = $.extend(options, Drupal.webform.select2.options);
        $('form.profile-customer-form select.form-select').chosen('destroy');
        $('form.profile-customer-form select.form-select').select2(options);

        $('form.profile-customer-form select.form-select').once('user-edit-form-address-change').change(function(){
          window.location.href = $('head link[rel="canonical"]').attr('href') + '?address=' +  $('form.profile-customer-form select.form-select').val();
        });
      }

    }
  }; // Drupal.behaviors.user_edit_form

})(jQuery, Drupal, drupalSettings);
